import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { changePassword } from '../../api/customer';

export default function ChangePassword() {
    const { id, pwd } = useParams<{ id: string; pwd: string }>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');

    useEffect(() => {
        if (!id || !pwd) {
            setErrorMessage('Некорректная ссылка для смены пароля');
            setIsLoading(false);
            return;
        }

        changePassword(id, pwd)
            .then((response) => {
                if (response.status === 'false' || response.status === false) {
                    setErrorMessage(response.error || 'Ошибка при смене пароля. ');
                } else {
                    setSuccessMessage(response.message || 'Пароль был успешно обновлён. Новый пароль отправлен Вам на почту');
                }
            })
            .catch((error: any) => {
                setErrorMessage(error.response?.data?.error || error.response?.data?.message || error.message || 'Ошибка при смене пароля');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [id, pwd]);

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    {isLoading && (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Загрузка...</span>
                            </div>
                        </div>
                    )}
                    {errorMessage && (
                        <div className="alert alert-danger text-center" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    {successMessage && (
                        <div className="alert alert-success  text-center" role="alert">
                            {successMessage}
                        </div>
                    )}
                    {!isLoading && (
                        <div className="text-center mt-3">
                            <a href="/" className="btn btn-primary btn-lg two">На главную</a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
